import updateData from "./updateData";

const reducer = (state, action) => {
    return {
        data: updateData(state, action)
    };
};

export default reducer;
